export enum FilterList {
	FINISHED = 'Finished',
	ACTIVE = 'Active',
	PENDING = 'Pending',
	MIN_MARGIN = 'Min Margin',
	MAX_MARGIN = 'Max Margin',
	NEWEST = 'Newest',
	OLDEST = 'Oldest',
}
